import { render, staticRenderFns } from "./BaseFetchMyRecord.vue?vue&type=template&id=00d7253f&scoped=true&"
import script from "./BaseFetchMyRecord.vue?vue&type=script&lang=js&"
export * from "./BaseFetchMyRecord.vue?vue&type=script&lang=js&"
import style0 from "./BaseFetchMyRecord.vue?vue&type=style&index=0&id=00d7253f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d7253f",
  null
  
)

export default component.exports